import type { Dispatch, SetStateAction, ReactNode } from 'react';
import React from 'react';
import { useIntl } from 'react-intl';

import {
	PopoverProvider,
	PopoverTarget,
	PopoverContent,
	SpotlightCard,
	SpotlightHeader,
	SpotlightHeadline,
	SpotlightControls,
	SpotlightDismissControl,
	SpotlightBody,
	SpotlightFooter,
	SpotlightActions,
	SpotlightPrimaryAction,
} from '@atlaskit/spotlight';
import { Text } from '@atlaskit/primitives/compiled/text';

import {
	useNav4CollapseReminderDismissal,
	nav4CollapseReminderI18n,
} from './nav4CollapseReminderHelpers.tsx';

type Nav4CollapseReminderPopoverProps = {
	children: ReactNode;
	isVisible: boolean;
	setIsNav4CollapseReminderSpotlightActive: Dispatch<SetStateAction<boolean>>;
};

export const Nav4CollapseReminderPopover = ({
	children,
	isVisible,
	setIsNav4CollapseReminderSpotlightActive,
}: Nav4CollapseReminderPopoverProps) => {
	const { formatMessage } = useIntl();
	const { dismissSpotlight } = useNav4CollapseReminderDismissal(
		setIsNav4CollapseReminderSpotlightActive,
	);

	return (
		<PopoverProvider>
			<PopoverTarget>{children}</PopoverTarget>
			<PopoverContent isVisible={isVisible} placement="right-end" dismiss={dismissSpotlight}>
				<SpotlightCard testId="nav4-collapse-reminder-spotlight">
					<SpotlightHeader>
						<SpotlightHeadline>{formatMessage(nav4CollapseReminderI18n.heading)}</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightBody>
						<Text>{formatMessage(nav4CollapseReminderI18n.body)}</Text>
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightActions>
							<SpotlightPrimaryAction onClick={dismissSpotlight}>
								{formatMessage(nav4CollapseReminderI18n.dismissButton)}
							</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider>
	);
};
